<template>
  <div class="app-container crm-detail">
    <el-card class="box-card mariginBottom" shadow="hover">
      <div slot="header" class="clearfix">
        <span>基本信息</span>
      </div>
      <el-row class="mariginBottom">
        <el-col :span="6">
          <div class="grid-content bg-purple">用户姓名：{{detail.nickName}}</div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple-light">备注：{{detail.remarkName}}</div>
        </el-col>
<!--        <el-col :span="6">-->
<!--          <div class="grid-content bg-purple">手机号：-->
<!--            <template v-if="detail.attentionCompany">-->
<!--              {{detail.phoneNumber}}-->
<!--            </template>-->
<!--            <template v-else>-->
<!--              {{ detail.phoneNumber.substring(0, 3)+"****"+ detail.phoneNumber.substr(detail.phoneNumber.length-4)}}-->
<!--            </template>-->
<!--          </div>-->
<!--        </el-col>-->
        <el-col :span="6">
          <div class="grid-content bg-purple">关注时间：{{detail.focusTime}}</div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">跟进人：{{detail.managerName}} <el-button type="primary" size="small" @click="handleDistribute()">分配</el-button></div>
        </el-col>
      </el-row>
      <el-row class="mariginBottom">
        <el-col :span="6">
          <div class="grid-content bg-purple-light">最新轨迹时间：{{detail.lastActiveTime}}</div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">CRM关联：{{detail.crmFlag=== 0 ? '否' : '是'}}</div>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="box-card mariginBottom" shadow="hover">
      <el-tabs v-model="activeName" @tab-click="handleQuery">
        <el-tab-pane label="潜在线索" name="first">
          <el-table v-loading="loading" :data="dataList">
            <el-table-column label="轨迹类型" min-width="150" align="center" prop="behaviorTypeStr" />
            <el-table-column label="描述" min-width="100" align="center" prop="description">
              <template slot-scope="scope">
                <span>{{scope.row.description1}}{{scope.row.description2}}{{scope.row.description3}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作时间" min-width="170" align="center" prop="createTime"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="CRM商机" name="second" v-if="detail.crmAuthFlag">
          <el-table v-loading="loading" :data="dataList">
            <el-table-column label="商机名称" min-width="150" align="center">
              <template slot-scope="scope">
                <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toDetail(scope.row)">{{scope.row.businessName}}</el-link>
              </template>
            </el-table-column>
            <el-table-column label="负责人" min-width="100" align="center" prop="userName" />
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="CRM客户联系人" name="third" v-if="detail.crmAuthFlag">
          <el-table v-loading="loading" :data="dataList">
            <el-table-column label="客户名称" min-width="150" align="center" prop="customerName">
              <template slot-scope="scope">
                <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toCustomerDetail(scope.row)">{{scope.row.customerName}}</el-link>
              </template>
            </el-table-column>
            <el-table-column label="联系人姓名" width="100" align="center">
              <template slot-scope="scope">
                <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toContactDetail(scope.row)">{{scope.row.name}}</el-link>
              </template>
            </el-table-column>
            <el-table-column label="负责人" min-width="100" align="center" prop="manager.managerName">
              <template slot-scope="scope">
                <span>{{scope.row.manager ? scope.row.manager.managerName : ""}}</span>
              </template>
            </el-table-column>
          </el-table>

        </el-tab-pane>
      </el-tabs>
      <pagination
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="handleClick"
      />
    </el-card>
    <AddManageDialog ref="addManageDialogRef" @success="potentialContactDetail"></AddManageDialog>
  </div>
</template>

<script>
import { potentialContactDetail, assign, queryClue, queryCrmContactList, queryBusiness } from "@/api/saas/package";
import AddManageDialog from './components/addManageDialog'
import { listUserWithOutDataScope } from "@/api/system/user";
export default {
  name: "InvoiceDetail",
  data() {
    return {
      activeName: 'first',
      loading: false,
      detail: {},
      dataList: [],
      id: null,
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      }
    };
  },
  components: {
    AddManageDialog
  },
  mounted(){
    this.id = this.$route.query.id
    potentialContactDetail({id: this.$route.query.id}).then(response => {
      this.detail = response.data
      this.handleClick({name: 'first'})
    });
  },
  methods: {
    potentialContactDetail(){
      potentialContactDetail({id: this.$route.query.id}).then(response => {
        this.detail = response.data
      });
    },
    handleQuery(){
      this.queryParams.pageNum = 1
      this.handleClick()
    },
    handleClick(){
      console.log('activename', this.activeName)
      if(this.activeName === 'first') {
        this.queryClue()
      }else if(this.activeName === 'second') {
        this.queryBusiness()
      }else if(this.activeName === 'third') {
        this.queryCrmContactList()
      }
    },
    queryClue() {
      queryClue(Object.assign(JSON.parse(JSON.stringify(this.queryParams)), {
        userId: this.detail.userId
      }))
        .then(response => {
          this.dataList = response.rows || [];
          this.loading = false;
          this.total = response.total;
        })
        .catch(error => {
          this.loading = false;
        });
    },
    queryBusiness() {
      // let queryParam = {
      //   pageNum: 1,
      //   pageSize: 100,
      //   contactMobile: this.detail.phoneNumber,
      //   businessStatusList: [0, 2] // 商机状态 0-转化中 1-输单 2-已成交 3-无效 4-挂起
      // }
      queryBusiness(Object.assign(JSON.parse(JSON.stringify(this.queryParams)),{
        contactMobile: this.detail.phoneNumber,
        businessStatusList: [0, 2] // 商机状态 0-转化中 1-输单 2-已成交 3-无效 4-挂起
      }))
        .then(response => {
          this.dataList = response.rows || [];
          this.loading = false;
          this.total = response.total;
        })
        .catch(error => {
          this.loading = false;
        });
    },
    queryCrmContactList() {
      // let queryParam = {
      //   pageNum: 1,
      //   pageSize: 100,
      //   mobileEq: this.detail.phoneNumber
      // }
      queryCrmContactList(Object.assign(JSON.parse(JSON.stringify(this.queryParams)), {mobileEq: this.detail.phoneNumber}))
        .then(response => {
          this.dataList = response.rows || [];
          this.loading = false;
          this.total = response.total;
        })
        .catch(error => {
          this.loading = false;
        });
    },
    handleDistribute() {
      this.$refs.addManageDialogRef.open(this.id)
    },
    /** 商机详细按钮操作 */
    toDetail(row) {
      this.$router.push("/crm/business/detail/" + row.businessId);
    },
    /** 联系人详细按钮操作 */
    toContactDetail(row) {
      this.$router.push("/crm/contact/detail/" + row.id);
    },
    // 客户详情
    toCustomerDetail(row) {
      this.$router.push("/crm/customer/detail/" + row.customerId);
    }
  }
};
</script>

<style lang='scss' scoped>
.mariginBottom {
  margin-bottom: 20px;
}
</style>

